import { useState } from 'react';
import { useStore, selectCreature, selectPlayerPos } from '@/infra/store';
import { useT } from '@/infra/i18n';
import { getCombatRunService } from '@/services/combat-run';
import { currentBiome } from '@/domain/world/region';
import { COLORS, SPACING, RADIUS, FONT } from '@/presentation/theme/tokens';
import { EnterRunModal } from '@/presentation/expedition/EnterRunModal';
import { CombatIcon } from '@/presentation/icons/CombatIcon';

export function EnterExpeditionButton() {
  const t = useT();
  const c = useStore(selectCreature);
  const pos = useStore(selectPlayerPos);
  const [open, setOpen] = useState(false);

  if (!c) return null;
  const stage = c.lifecycle.stage;
  const ready =
    (stage === 'adult' || stage === 'elder') &&
    !c.state.dead &&
    !c.state.sick &&
    c.state.vitality >= 30;

  const onProceed = (): void => {
    setOpen(false);
    const biome = currentBiome(pos.x, pos.y);
    getCombatRunService().start(biome);
  };

  return (
    <>
      <button
        data-testid="btn-expedition"
        title={ready ? t('expedition.title') : t('expedition.cannotStart.notReady')}
        disabled={!ready}
        onClick={() => setOpen(true)}
        style={{
          position: 'fixed',
          right: 16,
          bottom: 100,
          background: ready ? COLORS.surfaceSoft : 'rgba(40,40,50,0.5)',
          color: ready ? COLORS.danger : COLORS.textFaint,
          border: `2px solid ${ready ? COLORS.danger : COLORS.border}`,
          borderRadius: RADIUS.lg,
          padding: `${SPACING.sm + 2}px ${SPACING.md}px`,
          cursor: ready ? 'pointer' : 'not-allowed',
          fontSize: FONT.sizeSm,
          fontWeight: 600,
          zIndex: 90,
          backdropFilter: 'blur(6px)',
          animation: ready ? 'glow 1.6s ease-in-out infinite' : 'none',
        }}
      >
        <CombatIcon id="expedition" size={24} label="" style={{ verticalAlign: 'middle', marginRight: 6 }} />
        {t('expedition.start')}
        <style>{`@keyframes glow {0%,100%{box-shadow:0 0 0 rgba(255,110,110,0)}50%{box-shadow:0 0 12px rgba(255,110,110,0.7)}}`}</style>
      </button>
      <EnterRunModal
        open={open}
        biome={currentBiome(pos.x, pos.y)}
        creatureTypes={c.genome.primaryTypes}
        onCancel={() => setOpen(false)}
        onProceed={onProceed}
      />
    </>
  );
}
